export type NavigationMode = 'push' | 'replace';

export function navigateWithoutReload(path: string, mode: NavigationMode = 'replace') {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.location.pathname === path) {
    return;
  }

  if (mode === 'push') {
    window.history.pushState({}, '', path);
  } else {
    window.history.replaceState({}, '', path);
  }

  window.dispatchEvent(new PopStateEvent('popstate'));
}
